import { createFileRoute } from "@tanstack/react-router"
import { EvaluationPage } from "@/assignment"

// The evaluations_ prefix un-nests this route from evaluations.tsx (the
// list is a page, not a layout); the URL stays
// /t/$tenantSlug/evaluations/$assignmentId
export const Route = createFileRoute(
  "/(user)/t/$tenantSlug/evaluations_/$assignmentId",
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { assignmentId } = Route.useParams()

  return <EvaluationPage assignmentId={assignmentId} />
}
